export default __webpack_public_path__ + "static/media/COVER.264ab66b.jpg";